import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isFetchingByType: false,

  result: [],
};

const claimCPTCodesReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

  case types.GET_CPT_CODES_BY_TYPE_REQUEST:
    return {
      ...state,
      result: [],
      isFetchingByType: true,
    };

  case types.GET_CPT_CODES_BY_TYPE_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isFetchingByType: false,
    };

  case types.GET_CPT_CODES_BY_TYPE_FAILURE:
    return {
      ...state,
      result: [],
      isFetchingByType: false,
    };

  case types.GET_CPT_CODES_REQUEST:
    return {
      ...state,
      result: [],
      isFetching: true,
    };

  case types.GET_CPT_CODES_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isFetching: false,
    };

  case types.GET_CPT_CODES_FAILURE:
    return {
      ...state,
      result: [],
      isFetching: false,
    };

  default:
    return state;
  }
};

export default claimCPTCodesReducer;
